<template>
  <div class="schedule_detail">
    <div class="schedule-title">乘用车展区</div>
    <el-table
      :data="scheduleList"
      border
      style="width: 100%;"
      header-cell-class-name="header-row"
      :cell-style="{textAlign: 'center'}"
    >
      <el-table-column prop="dates" label="日期"></el-table-column>
      <el-table-column prop="times" label="时间"></el-table-column>
      <el-table-column prop="tips" label="温馨提示"></el-table-column>
    </el-table>
    <div class="schedule-title">商用车展区</div>
    <el-table
      :data="subScheduleList"
      border
      style="width: 100%;"
      header-cell-class-name="header-row"
      :cell-style="{textAlign: 'center'}"
    >
      <el-table-column prop="dates" label="日期"></el-table-column>
      <el-table-column prop="times" label="时间"></el-table-column>
      <el-table-column prop="tips" label="温馨提示"></el-table-column>
    </el-table>
    <div class="schedule-title">汽车产业链及汽车文化展区</div>
    <el-table
      :data="subScheduleList"
      border
      style="width: 100%;"
      header-cell-class-name="header-row"
      :cell-style="{textAlign: 'center'}"
    >
      <el-table-column prop="dates" label="日期"></el-table-column>
      <el-table-column prop="times" label="时间"></el-table-column>
      <el-table-column prop="tips" label="温馨提示"></el-table-column>
    </el-table>
    <!-- <div class="schedule-title">商用车</div>
    <el-table
      :data="subScheduleLists"
      border
      style="width: 100%;"
      header-cell-class-name="header-row"
      :cell-style="{textAlign: 'center'}"
    >
      <el-table-column prop="dates" label="日期"></el-table-column>
      <el-table-column prop="times" label="时间"></el-table-column>
      <el-table-column prop="tips" label="温馨提示"></el-table-column>
    </el-table> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      scheduleList: [
        {
          dates: "2024年11月15日（星期五）",
          times: "9:00-17:30",
          tips: "媒体日、仅限媒体"
        },
        {
          dates: "2024年11月16-17日（星期六-星期天）",
          times: "9:00-17:30",
          tips: "仅限专业观众"
        },
        {
          dates: "2024年11月18-24日（星期一-星期天）",
          times: "9:00-17:30",
          tips: "对公众和专业观众开放"
        }
      ],
      subScheduleList:[
         {
          dates: "2024年11月15-18日（星期五-星期一）",
          times: "9:00-17:30",
          tips: "媒体日仅对持证观众开放"
        }
      ],
      subScheduleLists:[
         {
          dates: "2023年1月5日-2023年1月8日（星期四-星期日）",
          times: "9:00-17:30",
          tips: "媒体日仅对持证观众开放"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.schedule_detail {
  width: 100%;
  display: flex;
  justify-content: center;
    flex-direction: column;
    .schedule-title{
      font-size: 30px;
      margin: 50px 0px;
    }
  // margin: 60px 0px;
}

@media screen and (max-width: 1000px) {
  .schedule_detail {
    width: 100vw;
   
    > img {
      width: 100vw;
      height: auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// scedule.vue?eeb5d4a8